import { Component, OnDestroy, OnInit } from '@angular/core';
import {fuseAnimations} from '../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService } from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {ELearningService} from '../../../core/services/e-learning.service';
import {Router} from '@angular/router';
import {LearnCategoryService} from '../../../core/services/learnCategory.service';
import {SpaceService} from '../../../core/services/space.service';
import { Subscription } from 'rxjs';
import { FuseConfigService } from '../../../core/services/config.service';

@Component({
    selector: 'e-learning-page',
    templateUrl: './e-learning.component.html',
    styleUrls: ['./e-learning.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class ELearningComponent implements OnInit, OnDestroy {

  eLearnings;
  boards = [];
  spaces = [];
  platformId = '';
  private subscriptions =  new Subscription();

  constructor (public dialog: MatDialog, public eLearningService: ELearningService, public spaceService: SpaceService,
               public snackBar: MatSnackBar, private spinner: NgxSpinnerService, public toastr: ToastrService,
               public translate: TranslateService, private router: Router, private fuseConfig: FuseConfigService) {
    this.subscriptions.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        if (res.id !== this.platformId && this.platformId) {
          this.platformId = res.id;
        }
        this.platformId = res.id;
      } else {
        this.platformId = '';
      }
      this.getELearnings();
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngOnInit () {
    this.spinner.show();
    this.translate.onLangChange.subscribe(lang => {
      this.getELearnings();
    });
    // this.getELearnings();
  }

  getELearnings () {
    this.spinner.show();
    this.spaceService.getSpaces(this.platformId).subscribe((spaces: any) => {
      this.eLearningService.getELearnings().subscribe((res: any) => {
        if (res && res.length) {
          this.boards = [];
          this.eLearnings = res;
          for (let i = 0; i < this.eLearnings.length; i++) {
            let spaceBoards = this.eLearnings[i].spaceBoards;
            for (let sp = 0; sp < spaceBoards.length; sp++) {
              let spIndex = this.boards.findIndex(el => +el.id === +spaceBoards[sp].id);
              if (spIndex === -1) {
                this.boards.push(spaceBoards[sp]);
                this.boards[this.boards.length - 1].elearning = [];
                this.boards[this.boards.length - 1].elearning.push(this.eLearnings[i]);
              } else {
                this.boards[spIndex].elearning.push(this.eLearnings[i]);
              }
            }
          }
          for (let i = 0; i < spaces.length; i++) {
            let boards = this.boards.filter(el => +el.spaceId === +spaces[i].id);
            if (boards.length) {
              spaces[i].boards = boards;
            }
          }
          this.spaces = spaces;
          console.log(this.spaces);
        }
        this.spinner.hide();
      });
    });

  }

  open(item) {
    this.router.navigate([ './pages/eLearning/detail' ], { queryParams: { id: item.id } });
  }

  preview(item) {
    this.router.navigate([ './pages/eLearning/preview' ], { queryParams: { id: item.id } });
  }
}

